import { render, staticRenderFns } from "./CardOrderEdit.vue?vue&type=template&id=4959b250&"
import script from "./CardOrderEdit.vue?vue&type=script&lang=js&"
export * from "./CardOrderEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports